import React from 'react';
import PropTypes from 'prop-types';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import DuplicateIcon from 'zignal-landscape/lib/Icon/DuplicateIcon';

import DuplicateCodingMenuBody from './DuplicateCodingMenuBody.js';

class DuplicateCodingMenu extends React.Component {
  constructor(props) {
    super(props);

    // With the purpose to avoid panel header to close on click of the icon
    this.stopEventPropagation = this.stopEventPropagation.bind(this);
  }

  stopEventPropagation(e) {
    e.stopPropagation();
  }

  render() {
    const { profiles } = this.props;
    if (profiles && profiles.length > 0 && this.props.visible) {
      return (
        <ToolTip
          position="bottomRight"
          trigger={['click']}
          destroyTooltipOnHide
          tooltipText={<DuplicateCodingMenuBody
            profiles={profiles}
            profileId={this.props.profileId}
            onSaveAndApply={this.props.onSaveAndApply}
          />}
        >
          <div onClick={this.stopEventPropagation}>
            <DuplicateIcon />
          </div>
        </ToolTip>
      );
    }
    return null;
  }
}

DuplicateCodingMenu.propTypes = {
  profiles: PropTypes.array.isRequired,
  profileId: PropTypes.string.isRequired,
  onSaveAndApply: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};


export default DuplicateCodingMenu;
